import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { AccountService } from '../auth-0/account.service';
import { environment } from 'src/environments/environment';
import { InitComponentApi } from '../api-dashboard/init_component_api.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  isAuthenticated$: Observable<boolean>;
  private info_usuario: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private accountService: AccountService,
    private initComponentApi: InitComponentApi
  ) {
    this.isAuthenticated$ = this.authService.isAuthenticated$;
  }

  async login(): Promise<void> {
    this.authService.loginWithRedirect().subscribe();
  }

  handleLoginCallback(): void {
    this.authService.handleRedirectCallback().subscribe(result => {
      localStorage.setItem('userProfile', JSON.stringify(result));
    });
  }

  logout(): void {
    this.authService.logout({
      logoutParams: {
        returnTo: environment.oidcConfig.end_session_redirect_url || window.location.origin,
        client_id: environment.oidcConfig.client_id,
      },
    });
    localStorage.clear();
  }

  isAuthenticated(): Observable<boolean> {
    return this.isAuthenticated$;
  }
}
